
    import { Component, Vue, Watch } from 'vue-property-decorator'
    const dy_1 = require('./../../../assets/imgs/dy_1.png'),
        dy_2 = require('./../../../assets/imgs/dy_2.png'),
        dy_3 = require('./../../../assets/imgs/dy_3.png'),
        dy_4 = require('./../../../assets/imgs/dy_4.png'),
        dy_5 = require('./../../../assets/imgs/dy_5.png');
    @Component({
        name: 'DashLayered'
    })
    export default class DashLayered extends Vue {
        private dyContentList: Array<any> = [
            { icon: dy_1, title: '培优', info: '注重夯实基础，确保简单题不丢分' },
            { icon: dy_2, title: '提高', info: '注重在基础知识上的再提升' },
            { icon: dy_3, title: '创新', info: '注重对数学难题的学习探索' },
            { icon: dy_4, title: '探索', info: '注重对全国决赛难度题目的学习' },
            { icon: dy_5, title: '好问', info: '全国高中数学联赛、CMO、<br />IMO难度题型的学习和掌握' }
        ]
    }
